import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  id: string | null;
  attributes?: Record<string, any>;
}

const loadUserFromLocalStorage = (): UserState => {
  try {
    const user = localStorage.getItem('userflow-user');
    if (user) {
      console.log('Got user from storage');
      return JSON.parse(user);
    }
  } catch (error) {
    console.error('Error loading user from localStorage', error);
  }
  return {
    id: null,
    attributes: {},
  };
};

const initialState: UserState = loadUserFromLocalStorage();

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserState>) => {
      state.id = action.payload.id;
      state.attributes = action.payload.attributes;
      localStorage.setItem('userflow-user', JSON.stringify(action.payload));
    },
    clearUser: (state) => {
      state.id = null;
      state.attributes = {};
      localStorage.removeItem('userflow-user');
    },
  },
});

export const selectUser = (state: any) => state.user;
export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
